import React, { useEffect } from "react";
import Header from "../../components/Header/Header";
import Donations from "../../components/Donations/Donations";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {

    const token = localStorage.getItem(`auth_token`)
    const navigate = useNavigate();

    useEffect (()=>{
        if(!token){
            navigate('/');
        }
    }, [navigate, token])
    
    
    return (
        <>        
            <Header />                
            <Donations />
        </>
    );
};
export default Dashboard;